// "uso"/"usos" concorda com o último número exibido ("0/1 uso", "1 uso").
export const usosLabel = (n: number | null | undefined) =>
  Number(n) === 1 ? 'uso' : 'usos'
